jQuery(document).ready(function ($) {
	function is_touch_enabled() {
		return ( 'ontouchstart' in window ) ||
					 ( navigator.maxTouchPoints > 0 ) ||
					 ( navigator.msMaxTouchPoints > 0 );
	}

	if(is_touch_enabled()){
		$('.side-bar__item').attr('data-device', 'touch');

		$('.side-bar__item .icon').click(function(){
			$parent = $(this).parent();
			$allItems = $('.side-bar__item');
			if($parent.hasClass('is-active')){
				$parent.removeClass('is-active');
			} else {
				$allItems.removeClass('is-active');
				$parent.addClass('is-active');
			}
		});
	}
	
});